let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cE0wB")).then(() => parcelRequire('hfe3g'));